import React, { useContext, createContext, useState, useEffect } from 'react';
import { Api } from './../../app-controller.js';
import ApiGS from '../../api/global.service';
import env from './../../environment.js';
import { useAuth } from '../../components/content/auth.jsx';
import transformWord from '../../utils/transformWord.js';
import { getJSON, setJSON } from '../../utils/localStorageJSON.js';
import ROLES from '../../constants/Roles.js';
// import InicioResume from '../../pages/admin/inicio-resume.js';

const coopConfigContext = createContext();

// Lee la configuración de la cooperativa de localStorage. Devuelve null si no
// existe o si el valor guardado está corrupto (ver utils/localStorageJSON.js).
const getStoredCoopConfig = () => getJSON(`${env.appName}-coop-config`);
// var globalConfig = {};
/**
 * ProvideCoopCopnfig wraps all our authentication methods
 */
export function ProvideCoopCopnfig({ children }) {
  const auth = useAuth();
  const [config, setConfig] = useState({});
  const [alerts, setAlerts] = useState({});
  const [loadingConfig, setLoadingConfig] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const configResponse = await getConfig();
      await getAlerts(configResponse?.id_ciclo_sic);
    };

    fetchData();
  }, []);

  // coop config data
  const getConfig = state => {
    if (auth.checkUser()) {
      return Api.fetch('acopios/catalogos/cooperativa_conf', state, 'GET')
        .then(response => {
          const coopConfigData = response?.[0];
          // setJSON borra la llave si coopConfigData es undefined, en lugar de
          // guardar la cadena "undefined" que luego rompe la lectura.
          setJSON(`${env.appName}-coop-config`, coopConfigData);
          setConfig(coopConfigData || {});
          setLoadingConfig(false);
          return coopConfigData;
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log('error loading configuration', e);
          setLoadingConfig(false);
        });
    }
  };

  // dashboard SIC or ACOPIO
  const getDashboard = () => {
    if (auth.checkUser()) {
      const dashboard = localStorage.getItem('dashboard');
      return dashboard ? dashboard : 'sic';
    }
  };

  const setDashboard = dashboard => {
    if (auth.checkUser()) {
      localStorage.setItem('dashboard', dashboard);
    }
  };

  // alerts
  const getAlerts = async ciclo_id => {
    if (auth.checkUser()) {
      // altas padron productores
      const padronAltas = await ApiGS.search('admin/sic/padron_altas', {
        filter: [
          { column: 'id_ciclo', operator: '=', value: ciclo_id },
          { column: 'confirmado', operator: '=', value: 0 },
        ],
      });

      const alerts = {
        padronAltas: padronAltas.data.length,
      };
      setAlerts(alerts);

      return alerts;
    }
  };

  const nuevaCuentaAcopio = () => {
    return Number(config.nueva_cuenta_acopio) === 1;
  };
  const estimacionCosecha = () => {
    return Number(config.estimacion_cosecha) === 1;
  };
  const adelantoEfectivo = () => {
    return Number(config.adelanto_efectivo) === 1;
  };
  const idCatCreditoPrecosecha = () => {
    return Number(config.id_cat_credito_precosecha) === 1;
  };
  const detalleIdsProductores = () => {
    return Number(config.detalle_ids_productores) === 1;
  };
  const detalleParcelas = () => {
    return Number(config.detalle_parcelas) === 1;
  };
  const mostrarCertificadora = () => {
    return Number(config.mostrar_certificadora) === 1;
  };
  const mostrarMuestreo = () => {
    return Number(config.mostrar_muestreo) === 1;
  };

  const usaWhatsapp = () => {
    return Number(config.usa_whatsapp) === 1;
  };

  const mostrarTipo = () => {
    return Number(config.mostrar_tipos) === 1;
  };

  const mostrarLote = () => {
    return Number(config.mostrar_lotes) === 1;
  };

  const mostrarCostalera = () => {
    let config = getStoredCoopConfig();
    return Number(config?.mostrar_costaleras) === 1;
  };

  const mostrarDescuento = () => {
    return Number(config.mostrar_descuento) === 1;
  };

  const mostrarDescuentoHumedad = () => {
    return Number(config.mostrar_descuento_humedad) === 1;
  };

  const mostrarDescuentosPorcentaje = () => {
    return Number(config.mostrar_descuentos_porcentaje) === 1;
  };

  const mostrarAreaCalculada = () => {
    return Number(config.mostrar_area_calculada) === 1;
  };

  const mostrarComiteEvalRA = () => {
    return Number(config.mostrar_comite_eval_ra) === 1;
  };

  const mostrarDashboardRechazados = () => {
    return Number(config.mostrar_dashboard_rechazados) === 1;
  };

  const acopioPagoXKilos = () => {
    return Number(config.acopio_pagos_por_kilos) === 1;
  };

  const mostrarCreditoPrecosecha = (_coopConfig = false) => {
    let _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return Number(_config.id_cat_credito_precosecha) !== 1;
  };

  const etiquetaAnticipos = async (tipos = ['singular']) => {
    let etiqueta = new String(config.anticipos_etiqueta);
    return transformWord(etiqueta, tipos);
  };

  const etiquetaParcelas = async (tipos = ['singular']) => {
    let etiqueta = new String(config.parcelas_etiqueta);
    return transformWord(etiqueta, tipos);
  };

  const etiquetaPlantas = async (tipos = ['singular']) => {
    let etiqueta = new String(config.plantas_etiqueta);
    return transformWord(etiqueta, tipos);
  };

  const etiquetaProducto = async (tipos = ['singular']) => {
    let etiqueta = new String(config.cooperativa?.producto?.nombre);
    return transformWord(etiqueta, tipos);
  };

  const mostrarDashboardInicio = (_coopConfig = false) => {
    let _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return Number(_config.mostrar_dashboard_inicio) === 1;
  };

  const mostrarDashboardProductores = (_coopConfig = false) => {
    let _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return Number(_config.mostrar_dashboard_productores) === 1;
  };

  const mostrarPadronCompleto = (_coopConfig = false) => {
    let _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return Number(_config.mostrar_padron_completo) === 1;
  };

  const mostrarPadronConcentrado = (_coopConfig = false) => {
    let _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return Number(_config.mostrar_padron_concentrado) === 1;
  };

  const mostrarLocalidadClave = (_coopConfig = false) => {
    let _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return Number(_config.mostrar_localidad_clave) !== 0;
  };

  const noMostrarPadronCambiarPath = (_coopConfig = false) => {
    let path = '/admin/padron/completo/list';
    let _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    if (Number(_config.mostrar_padron_completo) === 0) {
      return '/admin/padron/altas/list';
    }

    return path;
  };

  const acopioUnits = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return _config.acopio_units;
  };

  const acopioUnitsExtra = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return _config.acopio_units_extra;
  };

  const hasAcopioUnitsExtra = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return !!_config.acopio_units_extra;
  };

  const acopioUnitsConversion = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return _config.acopio_unit_conversions;
  };

  const currency = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return _config.currency;
  };

  const activeCicloAcopio = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return _config.activeCicloAcopio;
  };

  const activeCicloSIC = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return _config.activeCicloSIC;
  };

  const catCreditoPrecosecha = (_coopConfig = false) => {
    const _config = _coopConfig !== false ? JSON.parse(JSON.stringify(_coopConfig)) : config;
    return _config.cat_credito_precosecha;
  };

  /**
   * Visibilidad de una columna configurable por cooperativa (ej. padron_completo),
   * leída de cooperativas_config.configuracion_tablas. Si la cooperativa no tiene
   * config para esa tabla, o la columna no está explícitamente definida, se
   * conserva defaultVisible (el comportamiento por default, ej. café/miel).
   *
   * Estructura esperada en configuracion_tablas:
   * { "padron_completo": { "columnas": [ { "key": "region", "visible": true }, ... ] } }
   */
  const columnaVisible = (tabla, key, defaultVisible) => {
    const columnas = config?.configuracion_tablas?.[tabla]?.columnas;
    if (!Array.isArray(columnas)) {
      return defaultVisible;
    }
    const columna = columnas.find(c => c.key === key);
    if (!columna || columna.visible === undefined) {
      return defaultVisible;
    }
    return !!columna.visible;
  };

  const coopConfig = {
    config,
    getConfig,
    alerts,
    getAlerts,
    getDashboard,
    setDashboard,
    nuevaCuentaAcopio,
    estimacionCosecha,
    adelantoEfectivo,
    idCatCreditoPrecosecha,
    detalleIdsProductores,
    detalleParcelas,
    mostrarCertificadora,
    mostrarMuestreo,
    usaWhatsapp,
    mostrarTipo,
    mostrarLote,
    mostrarCostalera,
    mostrarDescuento,
    mostrarDescuentoHumedad,
    mostrarDescuentosPorcentaje,
    mostrarAreaCalculada,
    mostrarComiteEvalRA,
    mostrarDashboardRechazados,
    mostrarCreditoPrecosecha,
    acopioPagoXKilos,
    etiquetaAnticipos,
    etiquetaParcelas,
    etiquetaPlantas,
    etiquetaProducto,
    mostrarDashboardInicio,
    mostrarDashboardProductores,
    mostrarPadronCompleto,
    mostrarPadronConcentrado,
    mostrarLocalidadClave,
    noMostrarPadronCambiarPath,
    acopioUnits,
    acopioUnitsExtra,
    hasAcopioUnitsExtra,
    acopioUnitsConversion,
    currency,
    activeCicloAcopio,
    activeCicloSIC,
    catCreditoPrecosecha,
    columnaVisible,
    loadingConfig,
  };
  return <coopConfigContext.Provider value={coopConfig}>{children}</coopConfigContext.Provider>;
}

/**
 * useCoopConfig hook enables any component to get the current coopConfig state and re-render if it changes.
 **/

export function getRutaInicial(rutaInicial = '/dashboard') {
  let config = getStoredCoopConfig();
  let _rutaInicial = rutaInicial;
  if (config !== null) {
    if (Number(config.mostrar_dashboard_inicio) === 0) {
      _rutaInicial = '/admin/cuentas';
    }

    if (Number(config.mostrar_dashboard_inicio) === 0 && Number(config.mostrar_dashboard_productores) === 0) {
      _rutaInicial = '/admin/cuentas/list';
    }
  }

  return _rutaInicial;
}

const operators = {
  '=': (a, b) => a == b,
  '==': (a, b) => a === b,
  '!=': (a, b) => a != b,
  '>': (a, b) => a > b,
  '>=': (a, b) => a >= b,
  '<': (a, b) => a < b,
  '<=': (a, b) => a <= b,
};

const runCondition = (condition, variable, value) => {
  if (condition in operators) {
    return operators[condition](Number(variable), Number(value));
  } else {
    // eslint-disable-next-line no-console
    console.error(`Condition ${condition} not found in coop-config.js logic.`, '\n', 'Check menu and route files to fix problem.');
  }
};

export function filtrarRutas(rutas) {
  let config = getStoredCoopConfig();
  let _rutas = [];

  // Las rutas soloAdmin (pantallas de Súper Usuario) no existen para otros roles;
  // el API también las rechaza con 403 (middleware rol:1).
  const esAdmin = Number(getJSON(`${env.appName}-user`)?.id_rol) === ROLES.ADMIN;
  rutas = rutas.filter(ruta => !ruta.soloAdmin || esAdmin);

  if (config === null) {
    _rutas = rutas;
  } else {
    for (let r = 0; r < rutas.length; r++) {
      if (typeof rutas[r].coopconfig !== 'undefined') {
        const condition = rutas[r].coopconfig.cond;
        if (runCondition(condition, config[rutas[r].coopconfig.variable], rutas[r].coopconfig.value)) {
          _rutas.push(rutas[r]);
        }
      } else {
        _rutas.push(rutas[r]);
      }
    }
  }

  return _rutas;
}

export function filtrarMenu(menus) {
  let config = getStoredCoopConfig();
  let _menus = [];
  if (config === null) {
    _menus = menus;
  } else {
    for (let r = 0; r < menus.length; r++) {
      if (typeof menus[r].coopconfig !== 'undefined') {
        if (typeof menus[r].coopconfig.variable !== 'undefined') {
          const condition = menus[r].coopconfig.cond;
          if (runCondition(condition, config[menus[r].coopconfig.variable], menus[r].coopconfig.value)) {
            _menus.push(menus[r]);
          }
        } else {
          _menus.push(menus[r]);
        }
      } else {
        _menus.push(menus[r]);
      }
    }
  }
  return _menus;
}

export function showMenu(submenu) {
  let config = getStoredCoopConfig();
  let show = true;
  if (config !== null) {
    if (typeof submenu.coopconfig !== 'undefined') {
      if (typeof submenu.coopconfig.variable !== 'undefined') {
        const condition = submenu.coopconfig.cond;
        if (!runCondition(condition, config[submenu.coopconfig.variable], submenu.coopconfig.value)) {
          show = false;
        }
      }
    }
  }
  return show;
}

export function transformMenu(submenu) {
  let config = getStoredCoopConfig();
  if (config !== null) {
    if (typeof submenu.coopconfig2 !== 'undefined') {
      try {
        switch (submenu.coopconfig2) {
          case 'mostrarCreditoPrecosecha':
            submenu.title = transformWord(config.anticipos_etiqueta, ['plural', 'capitalize']);
            break;
          case 'noMostrarPadronCambiarPath':
            if (Number(config.mostrar_padron_completo) === 0) {
              submenu.path = '/admin/padron/concentrado/list';
            }

            if (Number(config.mostrar_padron_concentrado) === 0 && Number(config.mostrar_padron_concentrado) === 0) {
              submenu.path = '/admin/padron/altas/list';
            }
            break;
          case 'noMostrarProductoresDashboardCambiarPath':
            if (Number(config.usa_sic) === 0) {
              submenu.path = '/admin/cuentas/list';
            }
            break;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  }
  return submenu;
}

export function getIdCatCreditoPrecosecha() {
  let id_cat_credito_precosecha = 1;
  let config = getStoredCoopConfig();
  if (config !== null) {
    id_cat_credito_precosecha = config.id_cat_credito_precosecha;
  }

  return id_cat_credito_precosecha;
}

export function getUsaSic() {
  let usa_sic = 1;
  let config = getStoredCoopConfig();
  if (config !== null) {
    usa_sic = config.usa_sic;
  }
  return Number(usa_sic);
}

// Defaults to 1 (enabled) so cooperatives without the column set keep the
// Comité de Evaluación module visible.
export function getUsaComiteEvaluacion() {
  let usa_comite_evaluacion = 1;
  let config = JSON.parse(localStorage.getItem(`${env.appName}-coop-config`));
  if (config !== null && typeof config.usa_comite_evaluacion !== 'undefined') {
    usa_comite_evaluacion = config.usa_comite_evaluacion;
  }
  return Number(usa_comite_evaluacion);
}

export function getUsaEUDR() {
  let usa_eudr = 1;
  let config = getStoredCoopConfig();
  if (config !== null) {
    usa_eudr = config.usa_eudr;
  }
  return Number(usa_eudr);
}

export function getUsaEstimacionManual() {
  let usa_estimacion_manual = 1;
  let config = getStoredCoopConfig();
  if (config !== null) {
    usa_estimacion_manual = config.usa_estimacion_manual;
  }
  return Number(usa_estimacion_manual);
}

export function usaCentrosAcopios() {
  let usa_centros_acopios = 1;
  let config = getStoredCoopConfig();
  if (config !== null) {
    usa_centros_acopios = config.usa_centros_acopios;
  }
  return Number(usa_centros_acopios);
}

export function etiquetaAnticipos(tipos = ['singular', 'capitalize']) {
  let etiqueta = 'crédito';
  let config = getStoredCoopConfig();
  if (config !== null) {
    etiqueta = config.anticipos_etiqueta;
  }
  return transformWord(etiqueta, tipos);
}

export function precioPorKgEditable() {
  let valor = false;
  let config = getStoredCoopConfig();
  if (config !== null) {
    valor = Number(config.precio_por_kg_editable) === 1;
  }
  return valor;
}

export function precioPorKgPrecargado() {
  let valor = false;
  let config = getStoredCoopConfig();
  if (config !== null) {
    valor = Number(config.precio_por_kg_precargado) === 1;
  }
  return valor;
}

export function precioPorKgPorProductor() {
  let valor = false;
  let config = getStoredCoopConfig();
  if (config !== null) {
    valor = Number(config.precio_por_kg_por_productor) === 1;
  }
  return valor;
}

export function etiquetaParcelas(tipos = ['singular', 'capitalize']) {
  let etiqueta = 'parcela';
  let config = getStoredCoopConfig();
  if (config !== null) {
    etiqueta = config.parcelas_etiqueta;
  }
  return transformWord(etiqueta, tipos);
}

// Returns masculino/femenino ('e'/'a' by default) depending on whether the cooperative's
// parcelas_etiqueta is "apiario" (masculine) or anything else (feminine, e.g. "parcela").
// Override the defaults for words whose masculine form doesn't end in 'e' (e.g. 'o' for nuevo/nueva).
export function generoParcelas(masculino = 'e', femenino = 'a') {
  let etiqueta = 'parcela';
  let config = getStoredCoopConfig();
  if (config !== null) {
    etiqueta = config.parcelas_etiqueta;
  }
  return etiqueta
    ?.toString()
    .trim()
    .toLowerCase() === 'apiario'
    ? masculino
    : femenino;
}

export function etiquetaPlantas(tipos = ['singular', 'capitalize']) {
  let etiqueta = 'planta';
  let config = getStoredCoopConfig();
  if (config !== null) {
    etiqueta = config.plantas_etiqueta;
  }
  return transformWord(etiqueta, tipos);
}

export function etiquetaProducto(tipos = ['singular', 'capitalize']) {
  let etiqueta = 'café';
  let config = getStoredCoopConfig();
  if (config !== null) {
    etiqueta = config.cooperativa?.producto?.nombre || 'café';
  }
  return transformWord(etiqueta, tipos);
}

export function usaCodigoTx() {
  let usa_codigo_tx = false;
  let config = getStoredCoopConfig();
  if (config !== null) {
    usa_codigo_tx = Number(config.usa_codigo_tx) === 1;
  }
  return usa_codigo_tx;
}

export function usaMiel() {
  let usa_miel = false;
  let config = getStoredCoopConfig();
  if (config !== null) {
    usa_miel = config?.cooperativa?.id_cat_productos === 3;
  }
  return usa_miel;
}

export function useCoopConfig() {
  return useContext(coopConfigContext);
}

export function isMiel() {
  let config = getStoredCoopConfig();
  if (config !== null) {
    return Number(config.cooperativa?.producto?.id) === env.productos.MIEL;
  }
  return false;
}
